<div
  class="chat-state-panel d-flex flex-column align-items-center justify-content-center text-center gap-2 px-3"
  [class.py-5]="!compact"
  [class.py-4]="compact"
  role="alert"
>
  <!-- Soft disc + semantic glyph on the `avatar-title` itself — see the note in
       chat-empty-state.component.html (the wrapper tint sat behind the tile's
       solid `--ct-primary` fill). -->
  <div [ngClass]="compact ? 'avatar-sm' : 'avatar-lg'">
    <i
      class="avatar-title rounded-circle bg-soft-warning text-warning"
      [ngClass]="['ri-cloud-off-line', compact ? 'font-18' : 'font-24']"
    ></i>
  </div>

  <h5 class="mb-0">{{ 'chat.states.unavailableTitle' | translate }}</h5>
  <p class="text-muted mb-0">{{ 'chat.states.unavailableText' | translate }}</p>
  <p class="text-muted mb-0">{{ 'chat.states.unavailableHint' | translate }}</p>

  <button type="button" class="btn btn-sm btn-soft-primary mt-1" (click)="retry.emit()">
    <i class="ri-refresh-line me-1"></i>{{ 'chat.states.retry' | translate }}
  </button>
</div>
